import { addExtraStyles } from '@/top-loader-components/extra-styles';
import { addKetchLoader } from '@/top-loader-components/ketch-loader';

((win, doc) => {
  doc.onreadystatechange = () => {
    // if 'loading' - The document is loading.
    // if 'complete' - The page is fully loaded.
    if (doc.readyState === 'interactive') {
      // The document has finished loading, and we can access DOM elements.
      // Sub-resources such as scripts, images, stylesheets and frames are still loading.
      addKetchLoader(win, doc);
      addExtraStyles(doc);
    }
  };
})(window, document);
